import { useContext, useEffect, useRef, useState } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from 'primereact/button';
import { writeToken } from '../../utility/service/tool-service';


const CompanyRoleSelector = ({disabled=false,onRoleChange=null,changeToManager=false,type=""}) => {
    const { t } = useTranslation();
    const [color,setColor] = useState('');
    const [hasChanged, setHasChanged] = useState(false);
    const previousColorRef = useRef();


    const justifyOptions = [
        // 顧問
        { icon: 'fa-solid fa-user-tie', value: 'blue', label: 'company.b',colorValue:'blue' },
        // 廠商
        { icon: 'fa-solid fa-building', value: 'green', label: 'company.a',colorValue:'green' },
        // 管理者
        // { icon: 'fa-solid fa-user-gear', value: 'mint', label: 'company.m',colorValue:'mint' }
    ];

    const loadTheme = (themeName) => {
        writeToken("loadTheme",themeName);//每次切換都將主題寫入session中
        
        const defaultThemeName = 'green';
        const existingLink = document.querySelector('#app-theme');
        const link = document.createElement('link');
    
        link.id = 'app-theme-cloned';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `${process.env.PUBLIC_URL}/styles/theme_${themeName || defaultThemeName}.css`;
    
    
        link.onload = () => {
            existingLink && existingLink.remove();
            link.id = 'app-theme';
        }
    
        document.head.appendChild(link);
    }



    const handleRoleChange = (e) => {
        const newColor = e.colorValue;
        const changed = previousColorRef.current !== newColor;
            setHasChanged(changed);
            try {
                onRoleChange(newColor,changed); //避免有些地方不需使用此參數 
            } catch (error) {
                
            }
             
            loadTheme(e.value);
       
    }

    useEffect(()=>{
        if(changeToManager){
            loadTheme("mint");
            setColor("mint");
        }
    },[changeToManager])

    useEffect(()=>{
        if(type!==''){
            loadTheme(type);
            setColor(type);
        }
    },[type])


    useEffect(() => {
        let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
        loadTheme(themeColorSession);
        setColor(themeColorSession);
    }, []);

    useEffect(() => {
        previousColorRef.current = color;
      }, [color]);

    return (
        <div className="company-role-button">
            {justifyOptions.map(x => 
                <Button 
                    key={x.colorValue}
                    type='button'
                    disabled={disabled} 
                    className={color===x.colorValue?'p-highlight':''} 
                    onClick={() => {handleRoleChange(x);setColor(x.colorValue)}}>
                        <FontAwesomeIcon icon={x.icon} />
                        <span className='ml-1'>{t(x.label)}</span>
                </Button>)}
        </div>
    );

}
export default CompanyRoleSelector;